import Vue from 'vue'
import Router from 'vue-router'
import Learn from '@/components/views/Learn.vue'
import Quiz from '@/components/views/Quiz.vue'
import Exam from '@/components/views/Exam.vue'
import NotFound from '@/components/views/error/NotFound.vue'
import ProgramLevels from '@/components/views/ProgramLevels.vue'
import ProgramLevels62 from '@/components/views/ProgramLevels62.vue'
import ProgramLevels68 from '@/components/views/ProgramLevels68.vue'
import ProgramLevels69 from '@/components/views/ProgramLevels69.vue'
import Programs from '@/components/views/Programs/Index.vue'
import authRoutes from './auth-routes'
import guestRoutes from './guest'
import ContactSupport from '@/components/views/ContactSupport'
import Register from '@/components/views/auth/Register'
import ComplianceCenter from '@/components/views/ComplianceCenter.vue'
import ManagerActions from '@/components/views/ManagerActions.vue'
import BadgeAndCertificate from '../components/views/BadgeAndCertificate.vue'
import UpgradeLicense from '../components/views/UpgradeLicense.vue'
import Transfer from '../components/views/manager-actions/Transfer.vue'

Vue.use(Router)
const app = process.env.APP_NAME

const router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/404',
      name: '404',
      component: NotFound,
      meta: {title: `${app}: Home`, layout: 'standard', auth: undefined}
    },
    {
      path: '/support',
      name: 'ContactSupport',
      component: ContactSupport,
      meta: {auth: true, title: `${app}: Contact Support`, heading: 'Contact support', pageTitle: 'Contact support'}
    },
    {
      path: '/programs',
      name: 'Programs',
      component: Programs,
      meta: {title: `${app}: Programs`, pageTitle: 'My Programs', auth: true, layout: 'standard'}
    },
    {
      // Direct URL loads match this first; pick the component for the active GAME_ID
      // so a GAME 69 build renders ProgramLevels69 (not the first-declared duplicate route).
      path: '/program/:groupId/:deckId',
      name: 'ProgramLevels',
      component: (() => {
        switch (Number(process.env.GAME_ID)) {
          case 62:
            return ProgramLevels62
          case 52:
            return ProgramLevels
          case 68:
            return ProgramLevels68
          case 69:
            return ProgramLevels69
          default:
            return ProgramLevels
        }
      })(),
      meta: {title: `${app}: Program`, pageTitle: 'My Program', auth: true, layout: 'plain'}
    },
    {
      path: '/program/:groupId/:deckId',
      name: 'ProgramLevels68',
      component: ProgramLevels68,
      meta: {title: `${app}: Program`, pageTitle: 'My Program', auth: true, layout: 'plain'}
    },
    {
      path: '/program/:groupId/:deckId',
      name: 'ProgramLevels69',
      component: ProgramLevels69,
      meta: {title: `${app}: Program`, pageTitle: 'My Program', auth: true, layout: 'plain'}
    }, {
      path: '/learn/:groupId/:deckId/:level/:viewCount',
      name: 'Learn',
      component: Learn,
      meta: {title: `${app}: Learn`, pageTitle: 'Learn', auth: true, layout: 'plain'}
    }, {
      path: '/quiz/:groupId/:deckId/:level/:step',
      name: 'Quiz',
      component: Quiz,
      meta: {title: `${app}: Quiz`, pageTitle: 'Quiz', auth: true, layout: 'plain'}
    }, {
      path: '/exam/:groupId/:deckId/:step',
      name: 'Exam',
      component: Exam,
      meta: {title: `${app}: Exam`, pageTitle: 'Exam', auth: true, layout: 'plain'}
    }, {
      path: '/register/:step',
      name: 'Register',
      component: Register,
      meta: {auth: undefined, title: `${app}: Update Profile`, pageTitle: 'Update Profile', layout: 'standard'}
    },
    {
      path: '/compliance-center',
      name: 'ComplianceCenter',
      component: ComplianceCenter,
      meta: {title: `${app}: Compliance Center`, pageTitle: 'Compliance Center', auth: true, layout: 'standard'}
    },
    {
      path: '/manager-actions',
      name: 'ManagerActions',
      component: ManagerActions,
      meta: {title: `${app}: Manager Actions`, pageTitle: 'Manager Actions', auth: true, layout: 'standard'}
    },
    {
      path: '/actions',
      name: 'Actions',
      component: Transfer,
      meta: {title: `${app}: Manager Actions`, pageTitle: 'Manager Actions', auth: true, layout: 'standard'}
    },
    {
      path: '/badge-and-certificate/:groupId/:deckId',
      name: 'BadgeAndCertificate',
      component: BadgeAndCertificate,
      meta: {title: `${app}: BadgeAndCertificate`, pageTitle: 'Badge and certificate', auth: true, layout: 'standard'}
    },
    {
      path: '/upgrade-license/:groupId/:deckId',
      name: 'UpgradeLicense',
      component: UpgradeLicense,
      meta: {title: `${app}: Upgrade License`, pageTitle: 'Upgrade license', auth: true, layout: 'standard'}
    },
    ...authRoutes,
    ...guestRoutes,
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.fullPath !== '/user/payment') {
    if (to.fullPath === '/') {
      const login = localStorage.getItem('default_auth_token')
      if (login) {
        next({name: 'Programs'})
      } else {
        console.log('Login Fails in index router')
      }
    }
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js